const activityMeta = {
  templateId: 11, //活动id
  endCreate: '2018/11/06 00:00:00', // 团战开始时间
  endRegiment: '2018/11/13 00:00:00', //团战结束时间
  activityState: {
    start: 'start', // 组团期（活动开始）
    highTide: 'highTide', // 团战器（活动高潮）
    end: 'end', // 结算期(活动结束)
  },
  headSculpture: [
    // 头像
    {
      key: 1,
      url: 'https://img.alicdn.com/tfs/TB1CGDlk4naK1RjSZFBXXcW7VXa-300-300.png',
    },
    {
      key: 2,
      url: 'https://img.alicdn.com/tfs/TB1L4i3k9zqK1RjSZFjXXblCFXa-300-300.png',
    },
    {
      key: 3,
      url: 'https://img.alicdn.com/tfs/TB1Xby6k3HqK1RjSZFEXXcGMXXa-300-300.png',
    },
    {
      key: 4,
      url: 'https://img.alicdn.com/tfs/TB150K1k4TpK1RjSZFKXXa2wXXa-300-300.png',
    },
    {
      key: 5,
      url: 'https://img.alicdn.com/tfs/TB1afC2k9zqK1RjSZFpXXakSXXa-300-300.png',
    },
    {
      key: 6,
      url: 'https://img.alicdn.com/tfs/TB18lu2k5rpK1RjSZFhXXXSdXXa-300-300.png',
    },
    {
      key: 7,
      url: 'https://img.alicdn.com/tfs/TB1PkS2k9zqK1RjSZFHXXb3CpXa-300-300.png',
    },
    {
      key: 8,
      url: 'https://img.alicdn.com/tfs/TB1L75Tk9rqK1RjSZK9XXXyypXa-300-300.png',
    },
    {
      key: 9,
      url: 'https://img.alicdn.com/tfs/TB1PgO2kVzqK1RjSZFoXXbfcXXa-300-300.png',
    },
    {
      key: 10,
      url: 'https://img.alicdn.com/tfs/TB13Ne2k3TqK1RjSZPhXXXfOFXa-300-300.png',
    },
  ],
};

export default activityMeta;



// WEBPACK FOOTER //
// ./src/scripts/utils/activityMeta.js